import React from 'react';

import { Theme, seismicTheme, Button, Spinner, Tooltip } from '@seismic/mantle';

export const LoadingButton = ({ className }) => (
  <Theme
    theme={seismicTheme({
      useGlobal: true,
    })}
  >
    <Tooltip content={t('common.download_prep')}>
      <Button
        label={t('common.download')}
        startAdornment={<Spinner size={16} variant="ghost" />}
        aria-disabled
        data-testid="loading-button"
        className={className}
      />
    </Tooltip>
  </Theme>
);
